import { render, staticRenderFns } from "./VirtualControllerInfoTabs.vue?vue&type=template&id=11f84bbf"
import script from "./VirtualControllerInfoTabs.vue?vue&type=script&lang=ts"
export * from "./VirtualControllerInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports